<template>
  <div class="w-100 my-5">
    <div class="row mx-auto">
      <div class="col-sm m-2 box-white d-flex flex-column">
        <span class="fa fa-euro-sign font-15 color-blue">&nbsp;&nbsp;&nbsp;{{ $t('payback_amount') }}</span>
        <span class="mt-3 font-bold font-50 color-blue">{{ getPriceFormat(paybackAmount) }}</span>
      </div>
      <div class="col-sm m-2 box-white d-flex flex-column">
        <span class="fa fa-euro-sign font-15 color-red">&nbsp;&nbsp;&nbsp;{{ $t('already_paid') }}</span>
        <span class="mt-3 font-bold font-50 color-red">{{ getPriceFormat(paidAmount) }}</span>
      </div>
      <div class="col-sm m-2 box-white d-flex flex-column">
        <span class="fa fa-euro-sign font-15 color-blue">&nbsp;&nbsp;&nbsp;{{ $t('handling_fee') }}</span>
        <span class="mt-3 font-bold font-50 color-blue">{{ getPriceFormat(handlingFee) }}</span>
      </div>
    </div>
    <div class="row mx-auto">
      <div class="col-sm m-2 box-white row">
        <div class="col-sm my-1 vertical-center" v-if="eventInfo">
          <img :width="60" :height="40" :src="eventInfo.photoUrl" />
          <span class="ml-2 font-15 font-bold">{{ eventInfo.name }}</span>
        </div>
        <div class="col-sm my-1 vertical-center">
          <span class="font-bold font-15 alpha-07">{{ $t('requested') }}:</span>
          <span class="mx-5 font-bold font-20 color-blue" v-if="$route.params.eventId">{{ getDecimalFormat(items.length) }}</span>
          <span class="mx-5 font-bold font-20 color-blue" v-else>{{ `${getDecimalFormat(items.length)}${statsMap && statsMap['wristband'] ? ` / ${getDecimalFormat(statsMap['wristband'].payoutRequested)}` : ''}` }}</span>
        </div>
        <div class="col-sm my-1 vertical-center" v-if="!$route.params.eventId">
          <span class="font-bold font-15 alpha-07">{{ $t('sent') }}:</span>
          <span class="mx-5 font-bold font-20 color-blue">{{ statsMap && statsMap['wristband'] ? getDecimalFormat(statsMap['wristband'].payoutSent || 0) : 0 }}</span>
        </div>
        <div class="col-sm my-1 vertical-center" v-if="!$route.params.eventId">
          <span class="font-bold font-15 alpha-07">{{ $t('paid') }}:</span>
          <span class="mx-5 font-bold font-20 color-blue">{{ statsMap && statsMap['wristband'] ? getDecimalFormat(statsMap['wristband'].payoutPaid || 0) : 0 }}</span>
        </div>
        <div :class="`col-sm my-1 vertical-center ${isMobile ? '' : 'justify-content-end'}`">
          <input class="w-75" v-model="keyword" />
          <v-btn class="ml-2" icon small @click="keyword = ''" :disabled="!keyword">
            <i :class="`flaticon-circle ${keyword.length > 0 ? 'color-blue' : ''}`"></i>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="row mx-auto" v-for="(item, index) in items" :key="(item, index)">
      <div class="col-sm m-2 p-0 box-white row">
        <div class="col-sm d-flex flex-column">
          <div class="my-1 vertical-center pointer" @click="openOrganizerPage(item.organizerId)" v-if="item.organizerId">
            <img class="circle-image-30" :src="item.organizerPhotoUrl" />
            <span class="ml-2 ellipsis font-12" :title="item.organizerName">{{ item.organizerName }}</span>
            <img class="ml-2" :src="assets.openNewTab" width="15" />
          </div>
          <img width="200px" :src="item.eventPhotoUrl" />
          <span class="my-1 w-250px ellipsis font-bold font-12" :title="item.eventName">{{ item.eventName }}</span>
        </div>
        <div class="vertical-center">
          <div class="my-5 div-divider-h" v-if="isMobile" />
          <div class="mx-3 div-divider-v" v-else />
        </div>
        <div class="col-sm-4 d-flex flex-column">
          <span class="m-2 font-12" v-if="hostname === 'localhost'">ID: {{ item.payoutId }}</span>
          <div class="my-1 vertical-center pointer" @click="openUserPage(item.userId)">
            <img class="circle-image-30" :src="item.userPhotoUrl" />
            <span class="ml-2 ellipsis font-12" :title="item.userName">{{ item.userName }}</span>
            <img class="ml-2" :src="assets.openNewTab" width="15" />
          </div>
          <div class="mt-5 d-flex justify-content-between">
            <span class="font-12">PayPal</span>
            <span class="ml-2 font-12">{{ item.payPalAddress }}</span>
          </div>
          <div class="mt-5 d-flex justify-content-between">
            <span class="font-12 color-red">{{ $t('remain_balance') }}</span>
            <span class="ml-2 font-bold font-12 color-red">{{ getPriceFormat(item.balance || 0) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between" v-if="item.paidAt">
            <span class="font-12 color-red">{{ $t('paid') }}</span>
            <span class="ml-2 font-bold font-12 color-red">{{ getPriceFormat(item.payoutAmount + item.payoutFee) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between" v-else-if="item.sentAt">
            <span class="font-12 color-red">{{ $t('sent') }}</span>
            <span class="ml-2 font-bold font-12 color-red">{{ getPriceFormat(item.payoutAmount + (item.payoutFee || 0)) }}</span>
          </div>
          <div class="my-2 d-flex justify-content-between" v-if="item.handlingFee">
            <span class="font-12">{{ $t('handling_fee') }}</span>
            <span class="ml-2 font-12">{{ getPriceFormat(item.handlingFee) }}</span>
          </div>
        </div>
        <div class="vertical-center">
          <div class="my-5 div-divider-h" v-if="isMobile" />
          <div class="mx-3 div-divider-v" v-else />
        </div>
        <div class="col-sm d-flex flex-column">
          <span class="mt-2 font-bold font-15 color-red" v-if="item.eventId.startsWith(TEST_PREFIX)">Test</span>
          <div class="mt-2 d-flex justify-content-between">
            <span class="font-12">{{ $t('requested') }}</span>
            <span class="ml-2 font-bold font-12">{{ getDateStringFromTimestamp(item.requestedAt) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between" v-if="item.sentAt">
            <span class="font-12 color-red">{{ $t('sent') }}</span>
            <span class="ml-2 font-12 font-bold color-red">{{ getDateStringFromTimestamp(item.sentAt) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between" v-if="item.paidAt">
            <span class="font-12 color-blue">{{ $t('paid') }}</span>
            <span class="ml-2 font-12 font-bold color-blue">{{ getDateStringFromTimestamp(item.paidAt) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between" v-if="item.transactionStatus">
            <span class="font-12 font-bold color-blue">{{ item.transactionStatus }}</span>
            <span class="ml-2 font-12 font-bold color-blue" v-if="item.errors && item.errors.name">{{ item.errors.name }}</span>
          </div>
          <span class="my-2 font-12" v-if="item.errors && item.errors.message">{{ item.errors.message }}</span>
          <div class="my-2 d-flex justify-content-end">
            <v-btn class="button-normal" small @click="checkBalanceTask(item.payoutId, item.payPalAddress)" v-if="!item.sentAt && !item.paidAt">
              <span>{{ $t('pay_now') }}</span>
            </v-btn>
            <v-btn class="button-normal" small @click="getPayPalPayoutItemTask(item.eventId, item.payoutItemId)" v-if="hostname === 'localhost' && item.payoutItemId">
              <span>Check Payout Status</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="my-5 d-flex justify-content-center" v-if="hasMore">
      <v-btn text small @click="getPayoutListTask()">
        <span>Load More</span>
      </v-btn>
    </div>
    <div class="py-40 center" v-if="(items.length === 0)">
      <span class="font-20 alpha-07">{{ $t('no_data_found') }}</span>
    </div>
  </div>
</template>


<script>
import { httpsCallable } from 'firebase/functions';
import { functions, firestore } from '../../../main';
import { collection, doc, query, where, orderBy, limit, startAfter, getDocs, Timestamp, getDoc } from 'firebase/firestore';
import { getPriceFormat, getDecimalFormat, getDateStringFromTimestamp, showLoading } from '../../../functions';

import profile from '@/assets/image/profile.jpg';
import openNewTab from '@/assets/image/open_new_tab.png';

export default {
  name: 'WristbandPayoutList',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    statsMap() {
      return this.$store.state.statsMap;
    },
    organizerList() {
      return this.$store.state.organizerList || [];
    },
    eventList() {
      return this.$store.state.eventList || [];
    },
    eventInfo() {
      if (this.$route.params.eventId) {
        return this.eventList.find(element => element.eventId === this.$route.params.eventId);
      } else {
        return null;
      }
    },
    params() {
      return this.$route.params;
    }
  },
  watch: {
    params() {
      this.keyword = '';
      this.payoutList = [];
      this.getPayoutListTask();
    },
    eventList(newList, oldList) {
      if (oldList.length !== newList.length) {
        this.refreshData();
      }
    },
    organizerList(newList, oldList) {
      if (oldList.length !== newList.length) {
        this.refreshData();
      }
    },
    keyword() {
      this.refreshData();
    }
  },
  data() {
    return {
      assets: {
        profile,
        openNewTab
      },
      hostname: window.location.hostname,
      paybackAmount: 0,
      paidAmount: 0,
      handlingFee: 0,
      pageIndex: 1,
      hasMore: false,
      payoutList: [],
      cacheEventList: [],
      cacheUserList: [],
      wristbandList: [],
      items: [],
      keyword: ''
    }
  },
  mounted() {
    this.cacheUserList = this.$store.state.userList;
    this.payoutList = [];
    this.getPayoutListTask();
  },
  methods: {
    getPriceFormat,
    getDecimalFormat,
    getDateStringFromTimestamp,
    openOrganizerPage(userId) {
      window.open(`${window.location.origin}/users/1/${userId}`, '_blank');
    },
    openUserPage(userId) {
      window.open(`${window.location.origin}/users/0/${userId}`, '_blank');
    },
    refreshData() {
      var paybackAmount = 0;
      var paidAmount = 0;
      var handlingFee = 0;
      const items = [];
      const keyword = this.keyword.toLowerCase();
      this.payoutList.filter(element => element.requestedAt && (!this.$route.params.eventId || element.eventId === this.$route.params.eventId)).forEach(payoutInfo => {
        const item = JSON.parse(JSON.stringify(payoutInfo));
        const userInfo = this.cacheUserList.find(element => element.userId === payoutInfo.userId);
        const wristbandInfo = this.wristbandList.find(element => element.userId === payoutInfo.userId);
        const eventInfo = this.getEventInfo(payoutInfo.eventId);
        const organizerInfo = eventInfo ? this.organizerList.find(element => element.userId === eventInfo.userId) : null;
        item['userName'] = userInfo ? userInfo.userName : '';
        item['userPhotoUrl'] = userInfo ? userInfo.thumbnailUrl || userInfo.photoUrl || this.assets.profile : this.assets.profile;
        if (!payoutInfo.sentAt) {
          item['balance'] = wristbandInfo ? wristbandInfo.balance || 0 : 0;
        }
        item['eventName'] = eventInfo ? eventInfo.name : '';
        item['eventPhotoUrl'] = eventInfo ? eventInfo.thumbnailUrl || eventInfo.photoUrl : '';
        item['organizerId'] = organizerInfo ? organizerInfo.userId : '';
        item['organizerName'] = organizerInfo ? organizerInfo.userName : '';
        item['organizerPhotoUrl'] = organizerInfo ? organizerInfo.thumbnailUrl || organizerInfo.photoUrl || this.assets.profile : this.assets.profile;
        if (!keyword || !eventInfo || !userInfo || !organizerInfo ||
            (eventInfo && eventInfo.name.toLowerCase().includes(keyword)) ||
            (userInfo && userInfo.userName.toLowerCase().includes(keyword)) ||
            (organizerInfo && organizerInfo.userName.toLowerCase().includes(keyword))) {
          if (payoutInfo.paidAt) {
            paidAmount += payoutInfo.payoutAmount + payoutInfo.payoutFee;
          }
          if (payoutInfo.sentAt) {
            paybackAmount += payoutInfo.balance + payoutInfo.handlingFee;
          }
          if (payoutInfo.handlingFee) {
            handlingFee += payoutInfo.handlingFee;
          }
          items.push(item);
        }
      });
      items.sort((a, b) => (a.requestedAt.seconds < b.requestedAt.seconds) ? 1 : -1);
      this.paybackAmount = paybackAmount;
      this.paidAmount = paidAmount;
      this.handlingFee = handlingFee;
      this.items = items;
    },
    getEventInfo(eventId) {
      const cacheInfo = this.cacheEventList.find(element => element.eventId === eventId);
      if (cacheInfo) {
        return cacheInfo;
      } else {
        const eventInfo = this.eventList ? this.eventList.find(element => element.eventId === eventId) : null;
        if (eventInfo) {
          this.cacheEventList.push(eventInfo);
        }
        return eventInfo;
      }
    },
    getPayoutListTask() {
      let q;
      if (this.$route.params.eventId) {
        if (this.payoutList && this.payoutList.length > 0) {
          q = query(collection(firestore, 'wristbandPayout'), where('eventId', '==', this.$route.params.eventId), orderBy('requestedAt', 'desc'), limit(this.PAGE_LIMIT_200), startAfter(this.payoutList[this.payoutList.length - 1].requestedAt));
        } else {
          q = query(collection(firestore, 'wristbandPayout'), where('eventId', '==', this.$route.params.eventId), orderBy('requestedAt', 'desc'), limit(this.PAGE_LIMIT_200));
        }
      } else {
        if (this.payoutList && this.payoutList.length > 0) {
          q = query(collection(firestore, 'wristbandPayout'), orderBy('requestedAt', 'desc'), limit(this.PAGE_LIMIT_200), startAfter(this.payoutList[this.payoutList.length - 1].requestedAt));
        } else {
          q = query(collection(firestore, 'wristbandPayout'), orderBy('requestedAt', 'desc'), limit(this.PAGE_LIMIT_200));
        }
      }
      const loader = showLoading(this, 1);
      getDocs(q).then(querySnapshot => {
        loader.hide();
        const list = [];
        var userIDs = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          if (this.hostname === 'localhost' || !data.eventId.startsWith(this.TEST_PREFIX)) {
            list.push(data);
            if (!this.cacheUserList.find(element => element.userId === data.userId)) {
              userIDs.push(data.userId);
              if (userIDs.length >= 30) {
                this.getUserListTask(userIDs);
                userIDs = [];
              }
            }
            if (!data.sentAt && !data.paidAt) {
              this.getWristbandInfoTask(`${data.userId}_${data.eventId}`);
            }
          }
        });
        this.hasMore = querySnapshot.docs.length === this.PAGE_LIMIT_200;
        this.payoutList = this.payoutList.concat(list);
        this.refreshData();
        if (userIDs.length > 0) {
          this.getUserListTask(userIDs);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error('Unexpected error occurs - ' + error.message);
      });
    },
    getUserListTask(userIDs) {
      const q = query(collection(firestore, 'user'), where('userId', 'in', userIDs));
      getDocs(q).then(querySnapshot => {
        const list = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          const deviceType = data.deviceType || '';
          if (window.location.hostname === 'localhost') {
            data['deviceType'] = deviceType;
            if (deviceType.startsWith('Android : ')) {
              data['deviceTypeColor'] = 'color-red';
            } else if (deviceType.startsWith('iOS : ')) {
              data['deviceTypeColor'] = 'color-blue';
            } else if (deviceType.startsWith('Web : ')) {
              data['deviceTypeColor'] = 'color-purple';
            }
          } else {
            const myArray = deviceType.split(' : ');
            if (myArray && myArray.length > 0) {
              data['deviceType'] = myArray[0];
            } else {
              data['deviceType'] = '';
            }
            data['deviceTypeColor'] = 'color-primary';
          }
          if (data.userId === this.$route.params.userId) {
            this.userInfo = data;
          }
          list.push(data);
        });
        this.cacheUserList = this.cacheUserList.concat(list);
        this.$store.commit('set', ['userList', this.cacheUserList]);
        this.refreshData();
      });
    },
    getWristbandInfoTask(wristbandId) {
      getDoc(doc(firestore, 'wristband', wristbandId)).then(doc => {
        this.wristbandList.push(doc.data());
        this.refreshData();
      });
    },
    checkBalanceTask(payoutId, payPalAddress) {
      if (!payoutId || !payPalAddress) {
        this.$toast.error('Unexpected error occurs.');
        return;
      }
      const params = {
        functionName: 'payoutWristbandBalance',
        payoutId: payoutId
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data.status === true) {
          const amount = Number.parseInt(response.data.balance);
          if (amount > 0) {
            if (confirm(`Are you sure you want to pay ${getPriceFormat(amount)} to [${payPalAddress}] from your PayPal?`)) {
              this.doPayoutTask(payoutId);
            }
          } else {
            this.$toast.error('Unexpected error occurs.');
          }
        } else {
          this.$toast.error(response.data.message);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    },
    doPayoutTask(payoutId) {
      if (!payoutId) {
        this.$toast.error('Unexpected error occurs.');
        return;
      }
      const params = {
        functionName: 'payoutWristbandBalance',
        isPayout: true,
        payoutId: payoutId
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data.status === true) {
          for (let i = this.items.length; i--;) {
            if (this.items[i].payoutId === payoutId) {
              this.items[i]['balance'] = response.data.payoutInfo.balance;
              this.items[i]['payoutAmount'] = response.data.payoutInfo.payoutAmount;
              this.items[i]['handlingFee'] = response.data.payoutInfo.handlingFee;
              this.items[i]['sentAt'] = Timestamp.now();
            }
          }
          this.$toast.success('The payout was sent successfully.');
        } else {
          this.$toast.error(response.data.message);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    },
    getPayPalPayoutItemTask(eventId, payoutItemId) {
      if (!eventId || !payoutItemId) {
        this.$toast.error('Unexpected error occurs.');
        return;
      }
      const params = {
        functionName: 'getPayPalPayoutItem',
        eventId: eventId,
        payoutItemId: payoutItemId
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data.status === true) {
          window.alert(JSON.stringify(response.data.payoutItemInfo));
        } else {
          this.$toast.error(response.data.message);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>